/* src/app/modules/user/partnersequity/social-capital/social-capital-list.component.css */
/*# sourceMappingURL=social-capital-list.component.css.map */
